export const MINIMUM_PASSWORD_LENGTH = 8;

const PASSWORD_REQUIREMENTS = [
    {
        key: 'length',
        label: `Minimaal ${MINIMUM_PASSWORD_LENGTH} tekens`,
        matches: password => [...password].length >= MINIMUM_PASSWORD_LENGTH,
    },
    {
        key: 'uppercase',
        label: 'Minimaal één hoofdletter',
        matches: password => /[A-Z]/.test(password),
    },
    {
        key: 'lowercase',
        label: 'Minimaal één kleine letter',
        matches: password => /[a-z]/.test(password),
    },
    {
        key: 'digit',
        label: 'Minimaal één cijfer',
        matches: password => /\d/.test(password),
    },
    {
        key: 'special',
        label: 'Minimaal één speciaal teken',
        matches: password => /[^A-Za-z0-9]/.test(password),
    },
];

export function describePasswordRequirements(password) {
    const typed = typeof password === 'string' ? password : '';

    return PASSWORD_REQUIREMENTS.map(({key, label, matches}) => ({key, label, isMet: matches(typed)}));
}
